const Database = [
  {
    ward_no: 1,
    ward_name: "COVID Ward",
    ward_patient: 100,
    ward_worker: 50,
    clean_points: 5,
  },
  {
    ward_no: 2,
    ward_name: "BURN Ward",
    ward_patient: 20,
    ward_worker: 7,
    clean_points: 3,
  },
  {
    ward_no: 3,
    ward_name: "MATERNITY Ward",
    ward_patient: 10,
    ward_worker: 2,
    clean_points: 7,
  },
  {
    ward_no: 4,
    ward_name: "GENERAL Ward",
    ward_patient: 40,
    ward_worker: 3,
    clean_points: 4,
  },
];
export default Database;